import { render, staticRenderFns } from "./membership-detail.vue?vue&type=template&id=1ef23936&scoped=true&"
import script from "./membership-detail.vue?vue&type=script&lang=ts&"
export * from "./membership-detail.vue?vue&type=script&lang=ts&"
import style0 from "./membership-detail.vue?vue&type=style&index=0&id=1ef23936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef23936",
  null
  
)

component.options.__file = "membership-detail.vue"
export default component.exports